import { Box, Heading } from "@chakra-ui/react"
import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import PortfolioForm, { PortfolioFormData } from "../components/PortfolioForm"
import { useSetActivePortfolio, useUserDetails } from "../hooks/useAuthQueries"
import { useCreatePortfolio, useSavePortfolioCriteria } from "../hooks/usePortfolioQueries"

const CreatePortfolio: React.FC = () => {
  const navigate = useNavigate()
  const { data: userDetails } = useUserDetails()
  const createPortfolioMutation = useCreatePortfolio()
  const saveCriteriaMutation = useSavePortfolioCriteria()
  const setActivePortfolioMutation = useSetActivePortfolio()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const isPropertyInvestor =
    userDetails?.data?.organisation?.organisationType === "property_investment"

  const handleSubmit = async (data: PortfolioFormData) => {
    setIsSubmitting(true)
    try {
      const portfolio = await createPortfolioMutation.mutateAsync(data.name)
      await setActivePortfolioMutation.mutateAsync(portfolio.id)
      if (isPropertyInvestor) {
        await saveCriteriaMutation.mutateAsync({
          portfolioId: portfolio.id,
          data: {
            postcodes: data.postcodes,
            built_forms: data.built_forms,
            min_bedrooms: data.min_bedrooms,
            max_bedrooms: data.max_bedrooms,
            max_asking_price: data.max_asking_price,
            min_epc_band: data.min_epc_band
          }
        })
        navigate("/opportunities")
      } else {
        navigate("/portfolio")
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Box p={8}>
      <Heading size="xl" mb={6}>
        Create a new portfolio
      </Heading>
      <PortfolioForm
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        submitLabel="Create portfolio →"
        nameOnly={!isPropertyInvestor}
      />
    </Box>
  )
}

export default CreatePortfolio
